import { staffCommentFilesApi } from '@/app/api/deals/staffCommentFiles';
import { saveBinaryData } from '@/app/utils/Helpers';

// Обращаемся к адаптеру лениво: модуль участвует в цикле импортов Dataman → api/deals → services.
const api = () => staffCommentFilesApi.dealStaffCommentFiles;

/**
 * @param {number|string} dealId
 * @returns {Promise<Array<{id: number, originalName: string, createdAt: string}>>}
 */
export async function loadStaffCommentFiles(dealId) {
  const { data } = await api().getList({ deal: dealId });
  return data?.['hydra:member'] || data || [];
}

/**
 * @param {number|string} dealId
 * @param {{toAdd?: Array<File>, toDelete?: Array<number>}} changes
 */
export async function syncStaffCommentFiles(dealId, changes) {
  const { toAdd = [], toDelete = [] } = changes || {};
  if (!dealId || (!toAdd.length && !toDelete.length)) {
    return;
  }
  await Promise.all([
    ...toAdd.map((file) => api().create({ deal: `${dealId}`, file })),
    ...toDelete.map((id) => api().remove(id)),
  ]);
}

/**
 * @param {number} id
 * @param {string} name
 */
export async function downloadStaffCommentFile(id, name) {
  const response = await api().download(id);
  saveBinaryData(response.data, name);
}
